import { render, staticRenderFns } from "./PartnershipRegistraion.vue?vue&type=template&id=c85b4e66&scoped=true"
import script from "./PartnershipRegistraion.vue?vue&type=script&lang=js"
export * from "./PartnershipRegistraion.vue?vue&type=script&lang=js"
import style0 from "./PartnershipRegistraion.vue?vue&type=style&index=0&id=c85b4e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85b4e66",
  null
  
)

export default component.exports